import Image from "next/image";

export default function HighlightList({ subtitle, topTitle, reverse }) {
  return (
    <section>
      <div className="flex justify-center font-['Inter']">
        <div
          className={`${
            reverse
              ? "w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex flex-col items-center lg:justify-between lg:flex-row-reverse "
              : "w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex flex-col items-center lg:justify-between lg:flex-row "
          }`}
        >
          <div className="lg:w-1/2 px-16 pt-16 lg:p-16" tabIndex={0}>
            <p className="text-orange-400 font-bold mb-1">HOW WE CAN HELP</p>
            <h3 className="text-maingray text-4xl leading-tight font-bold md:leading-tight">
              Unlock the power of your data
            </h3>
          </div>
          <div className="lg:w-1/2 px-16 pt-16 lg:p-16 flex flex-col">
            <div className="w-full flex gap-4 items-center" tabIndex={0}>
              <Image width={41} height={41} 
                src="/assets/images/layout/icons8-checkmark.svg"
                className="h-[41px] w-[41px]"
                alt="Checkmark"
              ></Image>
              <p className="text-secgray text-lg">
                Maximize the value of your data
              </p>
            </div>
            <div className="w-full flex gap-4 items-center" tabIndex={0}>
              <Image width={41} height={41} 
                src="/assets/images/layout/icons8-checkmark.svg"
                className="h-[41px] w-[41px]"
                alt="Checkmark"
              ></Image>
              <p className="text-secgray text-lg">
                Streamline your data management processes
              </p>
            </div>
            <div className="w-full flex gap-4 items-center" tabIndex={0}>
              <Image width={41} height={41} 
                src="/assets/images/layout/icons8-checkmark.svg"
                alt="Checkmark"
                className="h-[41px] w-[41px]"
              ></Image>
              <p className="text-secgray text-lg">
                Improve collaboration and data sharing
              </p>
            </div>
            <div className="w-full flex gap-4 items-center" tabIndex={0}>
              <Image width={41} height={41} 
                src="/assets/images/layout/icons8-checkmark.svg"
                className="h-[41px] w-[41px]"
                alt="Checkmark"
              ></Image>
              <p className="text-secgray text-lg">
                Enhance your data visualization capabilities
              </p>
            </div>
            <div className="w-full flex gap-4 items-center" tabIndex={0}>
              <Image width={41} height={41} 
                src="/assets/images/layout/icons8-checkmark.svg"
                className="h-[41px] w-[41px]"
                alt="Checkmark"
              ></Image>
              <p className="text-secgray text-lg">
                Optimize the performance of your CKAN platform
              </p>
            </div>
            <div className="w-full flex gap-4 items-center" tabIndex={0}>
              <Image width={41} height={41} 
                src="/assets/images/layout/icons8-checkmark.svg"
                className="h-[41px] w-[41px]"
                alt="Checkmark"
              ></Image>
              <p className="text-secgray text-lg">
                Ensure compliance with industry standards and regulations
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
